import React, { useState, useEffect } from "react";
import {
  Card,
  Col,
  Row,
  Tabs,
  Tab,
  Form,
  Container,
  ListGroup,
  Button,
  Badge,
} from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import "./styles.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { formattedDateTime } from "../utility/dateFormate";
import { base_url } from "../api/api-url";
import { decryptText } from "../utility/cryptoUtils";
import { isAdminOrIsUser } from "../utility/isAdmin";
import { MenuItem, Select } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getVendors } from "../store/features/vendors/vendorSlice";

const priorityVariant = {
  Low: "success",
  Medium: "primary",
  High: "warning",
  Critical: "danger",
};

const ViewTicket = () => {
  const dispatch = useDispatch();
  const { ticketId } = useParams();
  const navigate = useNavigate();
  const statusOptions = isAdminOrIsUser()
    ? ["Open", "In Progress", "Escalated", "Resolved", "Closed"]
    : ["Open", "In Progress", "Escalated", "Resolved"];
  const [ticket, setTicket] = useState(null);
  const [loading, setLoading] = useState(true);

  // Separate state for each tab
  const [conversationText, setConversationText] = useState("");
  const [conversationFile, setConversationFile] = useState(null);
  const [isEditingConversation, setIsEditingConversation] = useState(true);
  const vendors = useSelector((state) => state.vendors.vendors) || "";

  console.log(vendors, "vendors");
  const clients = useSelector((state) => state.clientSlice.items) || "";

  const [resolutionText, setResolutionText] = useState("");
  const [resolutionFile, setResolutionFile] = useState(null);
  const [isEditingResolution, setIsEditingResolution] = useState(true);
  const [count, setCount] = useState(0);
  const [closedText, setClosedText] = useState("");
  const [closedFile, setClosedFile] = useState(null);
  const [isEditingClosed, setIsEditingClosed] = useState(true);

  const handleOpen = async (index) => {
    const updatedTickets = [ticket];
    updatedTickets[index].status = "Open";
    updatedTickets[index].updates?.push({
      date: new Date().toLocaleString(),
      note: "Ticket Open.",
    });

    setTicket((prev) => ({ ...prev, status: "Open" }));
    const tickID = updatedTickets[index]._id;
    const tickStatus = updatedTickets[index].status;
    try {
      const response = await fetch(`${base_url}/status-update/${tickID}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          status: tickStatus,
          changedByUser: `${localStorage.getItem("user_name")}-${decryptText(
            localStorage.getItem("email"),
          )}`,
        }),
      });

      if (!response.ok) {
        throw new Error(`Failed to create ticket: ${response.statusText}`);
      }

      const data = await response.json();
      // console.log("Ticket created successfully:", data);
      // You can show a success toast or navigate to another page here
    } catch (error) {
      console.error("Error while creating ticket:", error);
      // Show error toast or alert
    }
  };
  // useEffect(()=>{console.log(ticket,ticket.status,"ticket.status")},[ticket])
  const handleProgress = async (index) => {
    console.log(ticket, index);
    const updatedTickets = [ticket];
    updatedTickets[index].status = "In Progress";
    updatedTickets[index].updates?.push({
      date: new Date().toLocaleString(),
      note: "Ticket In Progress.",
    });
    setTicket((prev) => ({ ...prev, status: "" }));
    //  setTicket(updatedTickets[0]);
    const tickID = updatedTickets[index]._id;
    const tickStatus = updatedTickets[index].status;
    try {
      const response = await fetch(`${base_url}/status-update/${tickID}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          status: tickStatus,
          changedByUser: `${localStorage.getItem("user_name")}-${decryptText(
            localStorage.getItem("email"),
          )}`,
        }),
      });

      if (!response.ok) {
        throw new Error(`Failed to create ticket: ${response.statusText}`);
      }

      const data = await response.json();
      // console.log("Ticket created successfully:", data);
      // You can show a success toast or navigate to another page here
    } catch (error) {
      console.error("Error while creating ticket:", error);
      // Show error toast or alert
    }
  };

  const handleResloved = async (index) => {
    const updatedTickets = [ticket];
    updatedTickets[index].status = "Resolved";
    updatedTickets[index].updates?.push({
      date: new Date().toLocaleString(),
      note: "Ticket Resloved.",
    });
    setTicket(updatedTickets[0]);
    const tickID = updatedTickets[index]._id;
    const tickStatus = updatedTickets[index].status;
    try {
      const response = await fetch(`${base_url}/status-update/${tickID}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          status: tickStatus,
          changedByUser: `${localStorage.getItem("user_name")}-${decryptText(
            localStorage.getItem("email"),
          )}`,
        }),
      });

      if (!response.ok) {
        throw new Error(`Failed to create ticket: ${response.statusText}`);
      }

      const data = await response.json();
      // console.log("Ticket created successfully:", data);
      // You can show a success toast or navigate to another page here
    } catch (error) {
      console.error("Error while creating ticket:", error);
      // Show error toast or alert
    }
  };

  const handleCloseTicket = async (index) => {
    const updatedTickets = [ticket];
    updatedTickets[index].status = "Closed";
    updatedTickets[index].updates?.push({
      date: new Date().toLocaleString(),
      note: "Ticket closed.",
    });
    setTicket(updatedTickets[0]);
    const tickID = updatedTickets[index]._id;
    const tickStatus = updatedTickets[index].status;
    try {
      const response = await fetch(`${base_url}/status-update/${tickID}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          status: tickStatus,
          changedByUser: `${localStorage.getItem("user_name")}-${decryptText(
            localStorage.getItem("email"),
          )}`,
        }),
      });

      if (!response.ok) {
        throw new Error(`Failed to create ticket: ${response.statusText}`);
      }

      const data = await response.json();
      // console.log("Ticket created successfully:", data);
      // You can show a success toast or navigate to another page here
    } catch (error) {
      console.error("Error while creating ticket:", error);
      // Show error toast or alert
    }
  };

  const handleEscalate = async (index) => {
    const updatedTickets = [ticket];
    updatedTickets[index].status = "Escalated";
    updatedTickets[index].updates?.push({
      date: new Date().toLocaleString(),
      note: "Ticket escalated.",
    });
    console.log(updatedTickets, "updateTickets");
    setTicket(updatedTickets[0]);
    // const tickID = updatedTickets[index]._id;
    // const tickStatus = updatedTickets[index].status;

    console.log(updatedTickets[index]._id);
    // try {
    //   const response = await fetch(`${base_url}/status-update/${tickID}`, {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     body: JSON.stringify({
    //       status: tickStatus,
    //       changedByUser: `${localStorage.getItem("user_name")}-${decryptText(
    //         localStorage.getItem("email")
    //       )}`,
    //     }),
    //   });

    //   if (!response.ok) {
    //     throw new Error(`Failed to create ticket: ${response.statusText}`);
    //   }

    //   const data = await response.json();
    //   // console.log("Ticket created successfully:", data);
    //   // You can show a success toast or navigate to another page here
    // } catch (error) {
    //   console.error("Error while creating ticket:", error);
    //   // Show error toast or alert
    // }
  };

  useEffect(() => {
    dispatch(getVendors());
    const fetchTicket = async () => {
      try {
        const res = await fetch(`${base_url}/ticket/${ticketId}`);
        if (!res.ok) throw new Error("Ticket not found");
        const { data } = await res.json();
        console.log(data);

        setTicket(data);

        setConversationText(data.conversation?.message || "");
        setResolutionText(data.summary?.message || "");
        setClosedText(data.closedBy?.message || "");
      } catch (err) {
        console.error(err);
        setTicket(null);
      } finally {
        setLoading(false);
      }
    };
    fetchTicket();
  }, [ticketId]);

  const submitConversation = async () => {
    if (!conversationText.trim()) return;

    let uploadedUrl = "";
    if (conversationFile) {
      const fileData = new FormData();
      fileData.append("file", conversationFile);

      try {
        const uploadRes = await fetch(`${base_url}/upload`, {
          method: "POST",
          body: fileData,
        });

        if (!uploadRes.ok) {
          throw new Error("File upload failed");
        }

        const uploadResult = await uploadRes.json();
        if (uploadResult.success) {
          uploadedUrl = uploadResult.data.url;
        } else {
          console.error("Upload error:", uploadResult.message);
        }
      } catch (err) {
        console.error("File upload error:", err);
      }
    }

    // Step 2: Submit the conversation with uploaded file URL (if any)
    try {
      const res = await fetch(`${base_url}/update-conversation/${ticketId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          message: conversationText,
          image: uploadedUrl || "", // Send the uploaded file URL
        }),
      });

      const updatedData = await res.json();
      console.log("Conversation updated:", updatedData);

      setTicket((prev) => ({
        ...prev,
        conversation: updatedData.data.conversation,
      }));
      setIsEditingConversation(false);
      // setConversationText("");
      // setConversationFile(null); // Clear file
      setLoading(true);
      setLoading(false);
    } catch (err) {
      console.error("Error submitting conversation:", err);
    }
  };

  console.log(ticket, "Ticket");

  const submitResolution = async () => {
    if (!resolutionText.trim()) return;

    let uploadedUrl = "";

    // Step 1: Upload the file if it exists
    if (resolutionFile) {
      const fileData = new FormData();
      fileData.append("file", resolutionFile);

      try {
        const uploadRes = await fetch(`${base_url}/upload`, {
          method: "POST",
          body: fileData,
        });

        if (!uploadRes.ok) throw new Error("File upload failed");

        const uploadResult = await uploadRes.json();
        if (uploadResult.success) {
          uploadedUrl = uploadResult.data.url;
        } else {
          console.error("Upload error:", uploadResult.message);
        }
      } catch (err) {
        console.error("File upload error:", err);
      }
    }

    // Step 2: Submit the resolution message
    try {
      const res = await fetch(`${base_url}/update-summary/${ticketId}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          message: resolutionText,
          image: uploadedUrl || "",
        }),
      });

      // const { data: updatedData } = await res.json();
      const result = await res.json();
      if (result.success) {
        setTicket((prev) => ({
          ...prev,
          summary: result.data.summary, // <- FIXED this line
        }));
      }
      setIsEditingResolution(false);
      setLoading(true);
      setLoading(false);
      // setResolutionText("");
      // setResolutionFile(null);
    } catch (err) {
      console.error(err);
    }
  };

  const submitClosed = async () => {
    if (!closedText.trim()) return;

    let uploadedUrl = "";

    // Step 1: Upload the file if it exists
    if (closedFile) {
      const fileData = new FormData();
      fileData.append("file", closedFile);

      try {
        const uploadRes = await fetch(`${base_url}/upload`, {
          method: "POST",
          body: fileData,
        });

        if (!uploadRes.ok) throw new Error("File upload failed");

        const uploadResult = await uploadRes.json();
        if (uploadResult.success) {
          uploadedUrl = uploadResult.data.url;
        } else {
          console.error("Upload error:", uploadResult.message);
        }
      } catch (err) {
        console.error("File upload error:", err);
      }
    }

    // Step 2: Submit the closed message
    try {
      const res = await fetch(`${base_url}/update-closed/${ticketId}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          message: closedText,
          image: uploadedUrl || "",
        }),
      });

      // const { data: updatedData } = await res.json();
      // setTicket((prev) => ({ ...prev, closedBy: updatedData.data.closedBy }));
      const result = await res.json();
      if (result.success) {
        setTicket((prev) => ({
          ...prev,
          closedBy: result.data.closedBy, // <- FIXED
        }));
      }
      setIsEditingClosed(false);
      setLoading(true);
      setLoading(false);
      // setClosedText("");
      // setClosedFile(null);
    } catch (err) {
      console.error(err);
    }
  };

  if (loading)
    return <Container className="mt-5 text-center">Loading...</Container>;
  if (!ticket)
    return (
      <Container className="mt-5 text-center">
        <Button onClick={() => navigate(-1)} size="sm" variant="secondary">
          ← Back
        </Button>
        <h5 className="mt-3">Ticket not found</h5>
      </Container>
    );

  return (
    <Container className="py-4">
      <Button
        variant="outline-light"
        onClick={() => navigate(-1)}
        className="mb-3"
      >
        ← Back to Tickets
      </Button>
      <h2 className="mb-4 text-primary">{ticket.issueTitle}</h2>
      <Row className="g-4">
        <Col md={6}>
          <Card className="h-100 shadow-sm">
            <Card.Header className="bg-light">
              <h5>Ticket Details</h5>
            </Card.Header>
            <Card.Body>
              <ListGroup variant="flush">
                <ListGroup.Item>
                  <strong>Ticket No:</strong> {ticket.ticketId}
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>Department Ticket Id:</strong> {ticket.depTicketId}
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>Status:</strong>{" "}
                  <Badge bg="info">{ticket.status}</Badge>
                  {/* <Select
                                          value={ticket.status}
                                          onChange={(e) => {
                                            const newStatus = e.target.value;
                                            switch (newStatus) {
                                              case "Open":
                                                handleOpen(0);
                                                break;
                                              case "In Progress":
                                                handleProgress(0);
                                                break;
                                              case "Resolved":
                                                handleResloved(0);
                                                break;
                                              case "Escalated":
                                                handleEscalate(0);
                                                break;
                                              case "Closed":
                                                handleCloseTicket(0);
                                                break;
                                              default:
                                                break;
                                            }
                                          }}
                                          size="small"
                                          sx={{
                                            minWidth: 120,
                                            color: "black",
                                           
                                            ".MuiSelect-icon": {
                                              color: "black",
                                            },
                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                              borderColor: "black",
                                            },
                                            "&:hover .MuiOutlinedInput-notchedOutline": {
                                              borderColor: "black",
                                            },
                                          }}
                                          variant="outlined"
                                        >
                                          {statusOptions.map((status) => (
                                            <MenuItem key={status} value={status}>
                                              {status}
                                            </MenuItem>
                                          ))}
                                        </Select> */}
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>Priority:</strong>{" "}
                  <Badge bg={priorityVariant[ticket.priority] || "secondary"}>
                    {ticket.priority}
                  </Badge>
                </ListGroup.Item>

                <ListGroup.Item>
                  <strong>Department:</strong> {ticket.assignedDepartment.label}
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>Assigned To:</strong>{" "}
                  {ticket.assignedTo.map((u) => u.fullName).join(", ")}
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>Escalated By:</strong> {ticket.escalatedBy}
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>Escalated Date:</strong>{" "}
                  {formattedDateTime(ticket.escalationDate)}
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>Expected Resolve Data:</strong>{" "}
                  {formattedDateTime(ticket.expectedResolutionDate)}
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>Issue Category:</strong> {ticket.issueCategory}
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>Description:</strong>
                  <Card.Text className="mt-2">{ticket.description}</Card.Text>
                </ListGroup.Item>
                {ticket && (
                  <>
                    <ListGroup.Item>
                      <strong>Vendor:</strong>
                      <Card.Text className="mt-2">
                        {vendors?.find((v) => v._id === ticket.vendor)?.name || "-"}
                      </Card.Text>
                    </ListGroup.Item>

                    <ListGroup.Item>
                      <strong>Client:</strong>
                      <Card.Text className="mt-2">
                        {ticket?.client?.name || "-"}
                      </Card.Text>
                    </ListGroup.Item>
                  </>
                )}

                <ListGroup.Item>
                  <strong>Image:</strong>
                  <Card.Text className="mt-2">
                    {ticket?.files?.map((imgs, index) => (
                      <img
                        key={index}
                        src={imgs}
                        alt="issue image"
                        style={{ width: "50%", height: "50%" }}
                      />
                    ))}
                  </Card.Text>
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>Conversation:</strong>
                  <Card.Text className="mt-2">
                    {ticket?.conversation?.message}
                  </Card.Text>
                  {/* <Card.Text className="mt-2">
                    <img
                      src={ticket?.conversation?.image}
                      alt="issue image"
                      style={{ width: "50%", height: "50%" }}
                    />
                  </Card.Text> */}

                  <Card.Text className="mt-2">
                    {ticket?.conversation?.image &&
                      (() => {
                        const fileUrl = ticket?.conversation?.image;
                        const fileName = fileUrl.split("/").pop();
                        const fileExtension = fileName
                          ?.split(".")
                          .pop()
                          ?.toLowerCase();

                        const imageExtensions = [
                          "jpg",
                          "jpeg",
                          "png",
                          "gif",
                          "webp",
                        ];
                        const isImage = imageExtensions.includes(fileExtension);

                        return isImage ? (
                          <div>
                            <img
                              src={fileUrl}
                              alt="Uploaded issue"
                              style={{
                                width: "50%",
                                height: "auto",
                                borderRadius: "8px",
                              }}
                            />
                            <div className="mt-2">
                              <a
                                href={fileUrl}
                                download
                                className="btn btn-sm btn-primary"
                              >
                                Download Image
                              </a>
                            </div>
                          </div>
                        ) : (
                          <div>
                            <p>
                              <i
                                className="bi bi-file-earmark-text"
                                style={{
                                  fontSize: "1.2rem",
                                  marginRight: "8px",
                                }}
                              ></i>
                              {fileName}
                            </p>
                            <a
                              href={fileUrl}
                              download
                              className="btn btn-sm btn-success"
                            >
                              Download File
                            </a>
                          </div>
                        );
                      })()}
                  </Card.Text>
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>Resolution:</strong>
                  <Card.Text className="mt-2">
                    {ticket?.summary?.message}
                  </Card.Text>
                  {/* <Card.Text className="mt-2">
                    <img
                      src={ticket?.summary?.image}
                      alt="issue image"
                      style={{ width: "50%", height: "50%" }}
                    />
                  </Card.Text> */}

                  <Card.Text className="mt-2">
                    {ticket?.summary?.image &&
                      (() => {
                        const fileUrl = ticket?.summary?.image;
                        const fileName = fileUrl.split("/").pop();
                        const fileExtension = fileName
                          ?.split(".")
                          .pop()
                          ?.toLowerCase();

                        const imageExtensions = [
                          "jpg",
                          "jpeg",
                          "png",
                          "gif",
                          "webp",
                        ];
                        const isImage = imageExtensions.includes(fileExtension);

                        return isImage ? (
                          <div>
                            <img
                              src={fileUrl}
                              alt="Uploaded issue"
                              style={{
                                width: "50%",
                                height: "auto",
                                borderRadius: "8px",
                              }}
                            />
                            <div className="mt-2">
                              <a
                                href={fileUrl}
                                download
                                className="btn btn-sm btn-primary"
                              >
                                Download Image
                              </a>
                            </div>
                          </div>
                        ) : (
                          <div>
                            <p>
                              <i
                                className="bi bi-file-earmark-text"
                                style={{
                                  fontSize: "1.2rem",
                                  marginRight: "8px",
                                }}
                              ></i>
                              {fileName}
                            </p>
                            <a
                              href={fileUrl}
                              download
                              className="btn btn-sm btn-success"
                            >
                              Download File
                            </a>
                          </div>
                        );
                      })()}
                  </Card.Text>
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>ClosedBy:</strong>
                  <Card.Text className="mt-2">
                    {ticket?.closedBy?.message}
                  </Card.Text>
                  {/* <Card.Text className="mt-2">
                    <img
                      src={ticket?.closedBy?.image}
                      alt="issue image"
                      style={{ width: "50%", height: "50%" }}
                    />
                  </Card.Text> */}
                  <Card.Text className="mt-2">
                    {ticket?.closedBy?.image &&
                      (() => {
                        const fileUrl = ticket.closedBy.image;
                        const fileName = fileUrl.split("/").pop();
                        const fileExtension = fileName
                          ?.split(".")
                          .pop()
                          ?.toLowerCase();

                        const imageExtensions = [
                          "jpg",
                          "jpeg",
                          "png",
                          "gif",
                          "webp",
                        ];
                        const isImage = imageExtensions.includes(fileExtension);

                        return isImage ? (
                          <div>
                            <img
                              src={fileUrl}
                              alt="Uploaded issue"
                              style={{
                                width: "50%",
                                height: "auto",
                                borderRadius: "8px",
                              }}
                            />
                            <div className="mt-2">
                              <a
                                href={fileUrl}
                                download
                                className="btn btn-sm btn-primary"
                              >
                                Download Image
                              </a>
                            </div>
                          </div>
                        ) : (
                          <div>
                            <p>
                              <i
                                className="bi bi-file-earmark-text"
                                style={{
                                  fontSize: "1.2rem",
                                  marginRight: "8px",
                                }}
                              ></i>
                              {fileName}
                            </p>
                            <a
                              href={fileUrl}
                              download
                              className="btn btn-sm btn-success"
                            >
                              Download File
                            </a>
                          </div>
                        );
                      })()}
                  </Card.Text>
                </ListGroup.Item>
              </ListGroup>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <Card className="h-100 shadow-sm">
            <Card.Header className="bg-light">
              <h5>Activity</h5>
            </Card.Header>
            <Card.Body>
              <Tabs
                defaultActiveKey="conversation"
                id="ticket-tabs"
                fill
                className="mb-3"
              >
                <Tab eventKey="conversation" title="Conversation">
                  <Form.Group className="mb-3">
                    <Form.Label>Comment</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={conversationText}
                      onChange={(e) => setConversationText(e.target.value)}
                      readOnly={!isEditingConversation}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Attach File (optional)</Form.Label>
                    <Form.Control
                      type="file"
                      onChange={(e) => setConversationFile(e.target.files[0])}
                      disabled={!isEditingConversation}
                    />
                  </Form.Group>
                  <div className="text-end">
                    {isEditingConversation ? (
                      <Button onClick={submitConversation} size="sm">
                        Submit
                      </Button>
                    ) : (
                      <Button
                        variant="outline-secondary"
                        onClick={() => setIsEditingConversation(true)}
                        size="sm"
                      >
                        Edit
                      </Button>
                    )}
                  </div>
                </Tab>
                <Tab eventKey="resolution" title="Resolution">
                  <Form.Group className="mb-3">
                    <Form.Label>Resolution</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={resolutionText}
                      onChange={(e) => setResolutionText(e.target.value)}
                      readOnly={!isEditingResolution}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Attach File (optional)</Form.Label>
                    <Form.Control
                      type="file"
                      onChange={(e) => setResolutionFile(e.target.files[0])}
                      disabled={!isEditingResolution}
                    />
                  </Form.Group>
                  <div className="text-end">
                    {isEditingResolution ? (
                      <Button
                        variant="success"
                        onClick={submitResolution}
                        size="sm"
                      >
                        Submit
                      </Button>
                    ) : (
                      <Button
                        variant="outline-secondary"
                        onClick={() => setIsEditingResolution(true)}
                        size="sm"
                      >
                        Edit
                      </Button>
                    )}
                  </div>
                </Tab>
                <Tab eventKey="closedInfo" title="Closed Info">
                  <Form.Group className="mb-3">
                    <Form.Label>Closed Info</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={closedText}
                      onChange={(e) => setClosedText(e.target.value)}
                      readOnly={!isEditingClosed}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Attach File (optional)</Form.Label>
                    <Form.Control
                      type="file"
                      onChange={(e) => setClosedFile(e.target.files[0])}
                      disabled={!isEditingClosed}
                    />
                  </Form.Group>
                  <div className="text-end">
                    {isEditingClosed ? (
                      <Button
                        variant="warning"
                        onClick={submitClosed}
                        size="sm"
                      >
                        Submit
                      </Button>
                    ) : (
                      <Button
                        variant="outline-secondary"
                        onClick={() => setIsEditingClosed(true)}
                        size="sm"
                      >
                        Edit
                      </Button>
                    )}
                  </div>
                </Tab>
              </Tabs>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ViewTicket;
